export default __webpack_public_path__ + "static/media/Talons of Dark Terror.35ff650b.jpg";